module.exports = __webpack_public_path__ + "img/but_h5_pc.642e3664.png";